import { render, staticRenderFns } from "./releaseListCard.vue?vue&type=template&id=25e2b208"
var script = {}
import style0 from "./releaseListCard.vue?vue&type=style&index=0&id=25e2b208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports